import { RequireRole } from '@develio/auth/client';

export function SettingsMembersRoute() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Members</h2>
        <p className="mt-1 text-sm text-slate-500">Manage who can access this organization.</p>
      </div>

      <RequireRole
        requiredRole="owner"
        fallback={
          <div className="rounded-lg border border-slate-200 bg-amber-50 p-4 text-sm text-amber-900">
            Member management is visible to Owners only.
          </div>
        }
      >
        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <p className="text-sm text-slate-500">
            Use the organization switcher in the top bar to manage members via Clerk's built-in UI.
            Custom invitation flow ships in Sprint 6.
          </p>
        </div>
      </RequireRole>
    </div>
  );
}
